import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useCookies } from "react-cookie";
import Content from "layout/content/Content";
import Head from "layout/head/Head";
import { Block, BlockContent, BlockHead, BlockHeadContent, BlockTitle, InputSwitch } from "components/Component";
import { serviceGetAllSetting, servicePutSettings, serviceCreateSettings } from "services/settings";

const SETTING_CODE = "crm_agent_ai";
const SETTING_DESCRIPTION = "Mengaktifkan penggunaan Agent ID CRM pada channel";
const ALLOWED_ROLES = ["ADMIN", "SYSTEM ADMIN"];

const CrmAgentSetting = () => {
  const [cookies] = useCookies(["user"]);
  const [settingId, setSettingId] = useState("");
  const [enabled, setEnabled] = useState(false);

  const isAllowed = ALLOWED_ROLES.includes(cookies.role?.name);

  const initSetting = async () => {
    const response = await serviceGetAllSetting(cookies.SIDikey, SETTING_CODE);
    if (response?.status === 200) {
      const setting = response.data.data.find((item) => item.code === SETTING_CODE);
      if (setting) {
        setSettingId(setting.id);
        setEnabled(setting.value === "true");
      }
    }
  };

  useEffect(() => {
    if (isAllowed) initSetting();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isAllowed) {
    return <Redirect to={`${process.env.PUBLIC_URL}/`} />;
  }

  const handleToggle = async () => {
    const nextValue = !enabled;
    setEnabled(nextValue);

    if (settingId) {
      await servicePutSettings(cookies.SIDikey, settingId, {
        code: SETTING_CODE,
        value: nextValue.toString(),
        description: SETTING_DESCRIPTION,
      });
    } else {
      const response = await serviceCreateSettings(cookies.SIDikey, {
        code: SETTING_CODE,
        value: nextValue.toString(),
        description: SETTING_DESCRIPTION,
      });
      if (response?.data?.data?.id) setSettingId(response.data.data.id);
    }
  };

  return (
    <React.Fragment>
      <Head title="CRM Agent Setting"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle tag="h3" page>
              CRM Agent Setting
            </BlockTitle>
          </BlockHeadContent>
        </BlockHead>
        <Block>
          <BlockContent>
            <div className="g-item">
              <div className="custom-control custom-switch">
                <InputSwitch
                  id="crm-agent-ai-switch"
                  checked={enabled}
                  setChecked={setEnabled}
                  onChange={handleToggle}
                  label="Aktifkan Agent ID CRM"
                  caption={SETTING_DESCRIPTION}
                />
              </div>
            </div>
          </BlockContent>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default CrmAgentSetting;
